import axios from "axios";
import * as Constants from "../../Constants/index";

// Gives back the seats (and food) this booking is holding, with the
// engine's content/trans/cancel. The engine cancels only the signed-in
// customer's own transaction, and leaves a booking that is already BOOKED
// alone; even so, call this only when the payment has clearly NOT gone
// through (the engine said it was declined, the customer cancelled, or the
// time ran out) and never when the outcome is unknown, such as a network
// error after the card was sent.
//
// Resolves with the engine's answer ({ result, msg, ... }); rejects only when
// the engine could not be reached.
export const cancelTransaction = () => {
  const token = localStorage.getItem("token");
  return axios
    .post(
      Constants.api + "content/trans/cancel",
      {
        bookingId: localStorage.getItem("bookingid"),
        transid: localStorage.getItem("transid"),
        userId: localStorage.getItem("userid"),
      },
      {
        headers: {
          "Accept-Language": localStorage.getItem("language"),
          appversion: Constants.av,
          platform: window.matchMedia("(max-width: 575px)").matches ? "MSITE" : "WEBSITE",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((res) => (res && res.data ? res.data : null));
};

// Releases the held seats first and then runs next() (the message to the
// customer, the move to another page) whether the cancel worked or not: a
// failed cancel must never hide the decline from the customer, and the seats
// are released by the engine's own timeout in that case.
export const releaseSeatsThen = (next) =>
  cancelTransaction()
    .catch(() => null)
    .then((answer) => (next ? next(answer) : answer));
